export const sample_data = {
  "title": "MATH 1002 – Week 3 Leopardy",
  "teams": ["Steel", "Concrete", "Timber"],
  "version": "1.0",
  "categories": [
    {
      "name": "Ratios",
      "clues": [
        {
          "value": 100,
          "prompt": "A bowl has 6 apples and 7 oranges. Give the ratio apples:oranges in simplest form.",
          "answer": "6:7"
        },
        {
          "value": 200,
          "prompt": "State the hill’s ratio of height to length if the hill is 12 cm high and 96 cm long.",
          "answer": "1:8 (height:length)"
        },
        {
          "value": 300,
          "prompt": "Express “3 blue to 9 red” as a simplified ratio (blue:red).",
          "answer": "1:3"
        },
        {
          "value": 400,
          "prompt": "If a:b = 4:5 and b = 35, find a.",
          "answer": "28"
        },
        {
          "value": 500,
          "prompt": "Is “apples to hill height” a valid ratio? Why or why not?",
          "answer": "No—units aren’t comparable; ratios compare similar quantities."
        }
      ]
    },
    {
      "name": "Rearranging Equations",
      "clues": [
        {
          "value": 100,
          "prompt": "Solve for n: 25n = 275.",
          "answer": "n = 11"
        },
        {
          "value": 200,
          "prompt": "Solve for m: 6m = 96.",
          "answer": "m = 16"
        },
        {
          "value": 300,
          "prompt": "Solve for x: 100x = 550.",
          "answer": "x = 5.5"
        },
        {
          "value": 400,
          "prompt": "Solve for p: 88 = 8p.",
          "answer": "p = 11"
        },
        {
          "value": 500,
          "prompt": "Coffee costs $1.75 and you only have quarters. Set up and solve the equation to find how many quarters.",
          "answer": "1.75 = 0.25a → a = 7 quarters"
        }
      ]
    },
    {
      "name": "Direct vs Inverse Proportion",
      "clues": [
        {
          "value": 100,
          "prompt": "Identify the relationship: number of workers vs time to finish a fixed-size job.",
          "answer": "Inverse proportion"
        },
        {
          "value": 200,
          "prompt": "One raccoon shreds the garbage in 25 minutes. How long for 4 raccoons (same pile)?",
          "answer": "6.25 minutes (6 min 15 s)"
        },
        {
          "value": 300,
          "prompt": "A trip takes 2 hours at 50 mph. How long at 60 mph (same distance)?",
          "answer": "1 hour 40 minutes (1.666… h)"
        },
        {
          "value": 400,
          "prompt": "Gear A has twice as many teeth as Gear B. If Gear B spins at 20 turns/s, how fast is Gear A?",
          "answer": "10 turns per second (inverse to teeth count)"
        },
        {
          "value": 500,
          "prompt": "12 assemblers complete a job in 4 hours. If only 8 work, how long?",
          "answer": "6 hours"
        }
      ]
    },
    {
      "name": "Similar Shapes",
      "clues": [
        {
          "value": 100,
          "prompt": "Rectangles are similar. If 10′ corresponds to 12′, then 4′ corresponds to x. Find x.",
          "answer": "x = 4.8′"
        },
        {
          "value": 200,
          "prompt": "Segments are similar. If 1 cm corresponds to 6 cm, then 15 cm corresponds to s. Find s.",
          "answer": "s = 90 cm"
        },
        {
          "value": 300,
          "prompt": "Two similar triangles have a scale factor of 3:5. If the smaller’s side is 9, find the matching side of the larger.",
          "answer": "15"
        },
        {
          "value": 400,
          "prompt": "Similarity check: If two shapes have all corresponding angles equal and side ratios equal, what do we call them?",
          "answer": "Similar figures"
        },
        {
          "value": 500,
          "prompt": "In similar figures, by what factor does area scale when linear dimensions scale by k?",
          "answer": "k²"
        }
      ]
    },
    {
      "name": "Percents & Decimals",
      "clues": [
        {
          "value": 100,
          "prompt": "Write 0.375 as a percent.",
          "answer": "37.5%"
        },
        {
          "value": 200,
          "prompt": "Write 3.4 as a percent.",
          "answer": "340%"
        },
        {
          "value": 300,
          "prompt": "Write 0.02 as a percent.",
          "answer": "2%"
        },
        {
          "value": 400,
          "prompt": "What fraction of 12 is 3? Give the percent too.",
          "answer": "3/12 = 1/4 = 25%"
        },
        {
          "value": 500,
          "prompt": "Convert 28/100 to a percent and simplest fraction.",
          "answer": "28% and 7/25"
        }
      ]
    },
    {
      "name": "Percent Problems (Find P, R, B)",
      "clues": [
        {
          "value": 100,
          "prompt": "Find P: What is 45% of 75?",
          "answer": "33.75"
        },
        {
          "value": 200,
          "prompt": "Find R: 5 is what percent of 8?",
          "answer": "62.5%"
        },
        {
          "value": 300,
          "prompt": "Find R: What percent of 40 lb is 16 lb?",
          "answer": "40%"
        },
        {
          "value": 400,
          "prompt": "Find R: $9.90 is what percent of $18.00?",
          "answer": "55%"
        },
        {
          "value": 500,
          "prompt": "Find B: 8.7 is 30% of what number?",
          "answer": "29"
        }
      ]
    }
  ],
  "final_leopardy": {
    "category": "Proportion Word Problems",
    "prompt": "A medicine is 125 mg per 5 mL. How many mL deliver 500 mg?",
    "answer": "20 mL"
  },
  "bonus_clues": [
    {
      "category": "Gears",
      "prompt": "A mixing machine has a 6:1 gear ratio. If the driving gear has 12 teeth, how many teeth are on the driven gear?",
      "answer": "72 teeth"
    }
  ]
}
